export const EXCHANGES = {
  CMS: 'CMS',
  GAA: 'GAA',
} as const;

export type Exchange = 'CMS' | 'GAA';
